module.exports = __webpack_public_path__ + "25ed6de470313ee6632e2665d2baea12.ttf";